import {vertex,fragment} from './shejtano-background-shader.js?v=2026092401';
export function createBackgroundEngine(canvas,emit=()=>{}){
 const gl=canvas.getContext('webgl2',{alpha:false,antialias:false,depth:false,stencil:false,powerPreference:'low-power'});
 if(!gl)throw Error('Background WebGL unavailable');
 let frame=0,timer=0,deadline=0,reportAt=-Infinity,first=true,disposed=false;
 let state={width:1,height:1,epoch:performance.timeOrigin+performance.now(),running:false,animated:false,settings:{}};
 const program=gl.createProgram(),locations=new Map();
 for(const [type,code] of [[gl.VERTEX_SHADER,vertex],[gl.FRAGMENT_SHADER,fragment]]){
  const shader=gl.createShader(type);gl.shaderSource(shader,code);gl.compileShader(shader);
  if(!gl.getShaderParameter(shader,gl.COMPILE_STATUS))throw Error('Background shader failed');
  gl.attachShader(program,shader);gl.deleteShader(shader);
 }
 gl.linkProgram(program);if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error('Background program failed');gl.useProgram(program);
 const buffer=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buffer);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,3,-1,-1,3]),gl.STATIC_DRAW);
 const position=gl.getAttribLocation(program,'position');gl.enableVertexAttribArray(position);gl.vertexAttribPointer(position,2,gl.FLOAT,false,0,0);
 const location=name=>{if(!locations.has(name))locations.set(name,gl.getUniformLocation(program,name));return locations.get(name)};
 function stop(){if(frame&&typeof cancelAnimationFrame==='function')cancelAnimationFrame(frame);clearTimeout(timer);frame=timer=0;deadline=0}
 function draw(now){
  const time=Math.max(0,(performance.timeOrigin+now-state.epoch)/1000);
  gl.useProgram(program);gl.uniform1f(location('iTime'),time);gl.drawArrays(gl.TRIANGLES,0,3);
  if(first||now-reportAt>=100){emit({type:'frame',time,first});reportAt=now;first=false}
 }
 function schedule(){if(typeof requestAnimationFrame==='function')frame=requestAnimationFrame(tick);else timer=setTimeout(()=>tick(performance.now()),1000/30)}
 function tick(now){
  frame=timer=0;if(disposed||!state.running)return;
  if(!deadline||now>=deadline-.5){draw(now);deadline=now+1000/30-((now-(deadline||now))%(1000/30))}
  if(state.animated)schedule();
 }
 function update(next){
  if(disposed)return;state={...state,...next};
  const ratio=Math.min(1,Math.sqrt(300000/Math.max(1,state.width*state.height))),width=Math.max(1,Math.round(state.width*ratio)),height=Math.max(1,Math.round(state.height*ratio));
  if(canvas.width!==width||canvas.height!==height){canvas.width=width;canvas.height=height}
  gl.viewport(0,0,width,height);gl.useProgram(program);gl.uniform2f(location('iResolution'),width,height);
  for(const [name,value] of Object.entries(state.settings)){const loc=location(name);if(Array.isArray(value)){if(value.length===2)gl.uniform2fv(loc,value);else gl.uniform3fv(loc,value)}else gl.uniform1f(loc,value)}
  stop();if(state.running)tick(performance.now());
 }
 canvas.addEventListener('webglcontextlost',event=>{event.preventDefault();stop();emit({type:'error'})});
 return {update,dispose(){disposed=true;stop();gl.deleteBuffer(buffer);gl.deleteProgram(program)}};
}
